"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var DefaultConstraintValidationImpl = require("../constraint-validation/DefaultConstraintValidation-impl").implementation;

var _require = require("../../utils"),
    mixin = _require.mixin;

var _require2 = require("../../utils"),
    reflectURLAttribute = _require2.reflectURLAttribute;

var _require3 = require("../helpers/traversal"),
    closest = _require3.closest;

var HTMLObjectElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLObjectElementImpl, _HTMLElementImpl);

  function HTMLObjectElementImpl() {
    _classCallCheck(this, HTMLObjectElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLObjectElementImpl).apply(this, arguments));
  }

  _createClass(HTMLObjectElementImpl, [{
    key: "_barredFromConstraintValidationSpecialization",
    value: function _barredFromConstraintValidationSpecialization() {
      return true;
    }
  }, {
    key: "form",
    get: function get() {
      return closest(this, "form");
    }
  }, {
    key: "contentDocument",
    get: function get() {
      return null;
    }
  }, {
    key: "data",
    get: function get() {
      return reflectURLAttribute(this, "data");
    },
    set: function set(V) {
      this.setAttribute("data", V);
    }
  }, {
    key: "codeBase",
    get: function get() {
      return reflectURLAttribute(this, "codebase");
    },
    set: function set(V) {
      this.setAttribute("codebase", V);
    }
  }]);

  return HTMLObjectElementImpl;
}(HTMLElementImpl);

mixin(HTMLObjectElementImpl.prototype, DefaultConstraintValidationImpl.prototype);
module.exports = {
  implementation: HTMLObjectElementImpl
};